export const container = `bg-tertiary-1-300 w-4 h-4 rounded-full flex items-center justify-center`;
export const icon = `text-base-white`;
